import AutocompleteField from "../../../components/Form/AutocompleteField";
import { optionsAdsCampaignBreakdownsReport } from "../../../utils/options";
import { PILL_TRIGGER_VARIANT } from "../../../components/Buttons/PillTriggerButton";

const GlobalReportBreakdownSelector = ({ control, errors = {} }) => {
  return (
    <AutocompleteField
      name="breakdown"
      control={control}
      errors={errors}
      options={optionsAdsCampaignBreakdownsReport}
      doTranslate
      fullWidth={false}
      rules={{ required: false }}
      mode="text"
      triggerVariant={PILL_TRIGGER_VARIANT.PILL}
      sx={{ width: { xs: "100%", sm: "auto" } }}
    />
  );
};

export default GlobalReportBreakdownSelector;
